import React, { useState, useEffect } from "react";
import styles from "../commanstyles.module.css";
import { FaMinusSquare, FaPlusSquare } from "react-icons/fa";
import { IoMdLock } from "react-icons/io";

function MSME_supplier_payment_delays({ isSubScribe, data }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [isTableOpen, setIsTableOpen] = useState(true);
  const [selectedPeriod, setSelectedPeriod] = useState("");

  const [filteredData, setFilteredData] = useState([]);
  const rowsPerPage = 10;

  // Generate financial periods (April-September and October-March)
  const generateFinancialPeriods = () => {
    const periodsMap = new Map();
    
    data.forEach((row) => {
      const dueFrom = new Date(row.due_from);
      const month = dueFrom.getMonth(); // 0-11
      const year = dueFrom.getFullYear();

      let periodLabel, periodStart, periodEnd;

      if (month >= 3 && month <= 8) {
        // April to September
        periodLabel = `April to September ${year}`;
        periodStart = new Date(year, 3, 1); // April 1
        periodEnd = new Date(year, 8, 30); // September 30
      } else {
        // October to March
        const periodYear = month >= 9 ? year : year - 1;
        const nextYear = month >= 9 ? year + 1 : year;
        periodLabel = `October to March ${nextYear}`;
        periodStart = new Date(periodYear, 9, 1); // October 1
        periodEnd = new Date(nextYear, 2, 31); // March 31
      }

      // Use label as key to avoid duplicates
      if (!periodsMap.has(periodLabel)) {
        periodsMap.set(periodLabel, {
          label: periodLabel,
          start: periodStart,
          end: periodEnd
        });
      }
    });

    // Convert to array and sort by start date (most recent first)
    return Array.from(periodsMap.values()).sort((a, b) => b.start - a.start);
  };

  const availablePeriods = generateFinancialPeriods();

  useEffect(() => {
    let filtered = data;

    if (selectedPeriod) {
      const period = availablePeriods.find((p) => p.label === selectedPeriod);
      if (period) {
        filtered = filtered.filter((row) => {
          const rowDueFrom = new Date(row.due_from);
          const rowDueTo = new Date(row.due_to);
          // Check if row's date range overlaps with selected period
          return rowDueFrom <= period.end && rowDueTo >= period.start;
        });
      }
    }

    setFilteredData(filtered);
    setCurrentPage(1);
  }, [selectedPeriod, data, availablePeriods]);

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = filteredData.slice(indexOfFirstRow, indexOfLastRow);

  const toggleTable = () => {
    setIsTableOpen(!isTableOpen);
  };

  return (
    <div className={styles.table_subcontainer}>
      <div>
        {isSubScribe && (
          <div className={styles.highlet_header_content1}>
            <p className={styles.minuse_icon} onClick={toggleTable}>
              {isTableOpen ? (
                <FaMinusSquare size={22} />
              ) : (
                <FaPlusSquare size={22} />
              )}
            </p>
            <h3 className={styles.highlet_text}>
              {/* MSME SUPPLIER PAYMENT DELAYS FOR PERIOD -  31 Mar, {selectedYear || "All"} */}
              MSME Supplier Paymeny Delays For Period
              {filteredData.length > 0 &&
                selectedPeriod &&
                `  - ${selectedPeriod}`}
              {data.length > 0 && (
                <div className={styles.yearSelectContainer}>
                  <select
                    value={selectedPeriod}
                    onChange={(e) => setSelectedPeriod(e.target.value)}
                    className={styles.yearDropdown}
                  >
                    <option value="">Select a Period</option>
                    {availablePeriods.map((period, index) => (
                      <option key={index} value={period.label}>
                        {period.label}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </h3>
          </div>
        )}

        {isTableOpen && (
          <>
            {!isSubScribe && (
              <button className={styles.Subscription_msg}>
                <IoMdLock /> Subscription required to view data
              </button>
            )}

            {isSubScribe && (
              <>
                {/* Year selection dropdown */}

                <table className={styles.commantable}>
                  <thead>
                    <tr className={styles.tableHeaderRow}>
                      <th className={styles.tableHeader}>S.No</th>
                      <th className={styles.tableHeader}>Name of Supplier</th>
                      <th className={styles.tableHeader}>PAN of Supplier</th>
                      <th className={styles.tableHeader}>Amount Due</th>
                      <th className={styles.tableHeader}>Due From</th>
                      <th className={styles.tableHeader}>Due To</th>
                      <th className={styles.tableHeader}>
                        Reference Documents
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentData.length > 0 ? (
                      currentData.map((row, index) => (
                        <tr key={row.id} className={styles.tableRow}>
                          <td className={styles.tableCell}>{index + 1}</td>
                          <td className={styles.tableCell}>
                            {row.supplier_name}
                          </td>
                          <td className={styles.tableCell}>
                            {row.pan_of_supplier}
                          </td>
                          <td className={styles.tableCell}>{row.amount_due}</td>
                          <td className={styles.tableCell}>
                            {new Date(row.due_from).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              }
                            )}
                          </td>
                           <td className={styles.tableCell}>
                            {new Date(row.due_to).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              }
                            )}
                          </td>
                          <td className={styles.tableCell}>
                            {row.referenceDoc && row.referenceDoc.length > 0
                              ? row.referenceDoc.map((doc, index) => (
                                  <div key={index}>
                                    <a
                                      href={doc.fileurl}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        color: "#2961EF",
                                        textDecoration: "none",
                                      }}
                                    >
                                      {doc.Name}
                                    </a>
                                  </div>
                                ))
                              : "-"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className={styles.noData} style={{textAlign:"center"}}>
                          No MSME Supplier Payment Delays data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </>
            )}

            {/* Pagination controls */}
            {isSubScribe && currentData.length > 0 && (
              <div className={styles.pagination}>
                <button onClick={handlePrevious} disabled={currentPage === 1}>
                  &lt;
                </button>
                {[...Array(totalPages).keys()].map((num) => (
                  <button
                    key={num + 1}
                    onClick={() => handleClick(num + 1)}
                    className={currentPage === num + 1 ? styles.active : ""}
                  >
                    {num + 1}
                  </button>
                ))}
                <button
                  onClick={handleNext}
                  disabled={currentPage === totalPages}
                >
                  &gt;
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default MSME_supplier_payment_delays;
